import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComingSoonSectionProps {
  title: string;
  description: string;
  icon: string;
}

const ComingSoonSection = ({ title, description, icon }: ComingSoonSectionProps) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg p-8 lg:p-12 text-center">
      <div className="flex justify-center mb-6">
        <div className="relative">
          <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full"></div>
          <Icon 
            name={icon as any} 
            size={56} 
            className="text-primary relative z-10"
          />
        </div>
      </div>
      
      <h3 className="font-playfair text-2xl lg:text-3xl font-bold text-foreground mb-3">
        {title}
      </h3>
      
      <p className="font-inter text-base text-muted-foreground max-w-2xl mx-auto">
        {description}
      </p>
      
      <div className="mt-6 inline-flex items-center space-x-2 px-6 py-3 bg-primary/10 rounded-full">
        <Icon name="ClockIcon" size={20} className="text-primary" />
        <span className="font-inter text-sm font-medium text-primary">
          Coming Soon
        </span>
      </div>
    </div>
  );
};

export default ComingSoonSection;